import { type Task } from '@/types/Task'

export function createTask(data: Partial<Task> = {}): Task {
  return {
    id: data.id || crypto.randomUUID(),
    title: data.title || '',
    description: data.description,
    organizationId: data.organizationId,
    personId: data.personId,
    vehicleId: data.vehicleId,
    transactionId: data.transactionId,
    organizationName: data.organizationName,
    personName: data.personName,
    status: data.status || 'todo',
    dueAt: data.dueAt,
    createdAt: data.createdAt || new Date(),
    updatedAt: data.updatedAt || new Date(),
    createdBy: data.createdBy,
    assignedTo: data.assignedTo,
    tags: data.tags || [],
    isDeleted: data.isDeleted || false,
  }
}
